/* ------------------------------- transaction ------------------------------ */

export const PURCHASE_STATUSES = ['PRE_OFFER', 'UNDER_CONTRACT', 'CLOSED'];
